import { ApproveAction } from '../types'
import { normalizeErc20AbiForToken } from './normalizeErc20Abi'
import { allowanceQueryKey, readAllowance } from './query'
import { ensureConfigTypes } from '@/features/actions/logic/transactions/useWrite'
import { ActionConfig, ActionContext } from '@/features/actions/logic/types'

export function createApproveActionConfig(action: ApproveAction, context: ActionContext): ActionConfig {
  const { wagmiConfig, account, chainId } = context

  const allowanceOptions = {
    token: action.token.address,
    spender: action.spender,
    wagmiConfig,
    account,
    chainId,
  }

  return {
    getInitialParams: async () => {
      const data = await readAllowance(allowanceOptions)
      return { canBeSkipped: data >= action.token.toBigInt(action.requiredValue ?? action.value) }
    },

    getWriteConfig: () => {
      const value = action.token.toBigInt(action.value)
      const address = action.token.address

      return ensureConfigTypes({
        address,
        abi: normalizeErc20AbiForToken(chainId, address),
        functionName: 'approve',
        args: [action.spender, value],
      })
    },

    verifyTransaction: async () => {
      const data = await readAllowance(allowanceOptions)
      return { success: data >= action.token.toBigInt(action.value) }
    },

    invalidates: () => [allowanceQueryKey({ token: action.token.address, spender: action.spender, account, chainId })],
  }
}
